import { useCallback, useMemo } from "react";

import { type UseGetAllRolesOptions, useGetAllRoles } from "src/api/client-api/roles/useGetAllRoles";

export const useRoles = (options?: UseGetAllRolesOptions) => {
    const { allRoles: roles, isLoading: rolesLoading } = useGetAllRoles(options);

    const roleDisplayNames = useMemo(
        () =>
            new Map<string, string>([
                ["ROLE_ADMIN", "Admin"],
                ["ROLE_FOODPILOT", "FoodPilot"],
                ...(roles?.map(({ code, displayName }) => [code, displayName] as const) ?? []),
            ]),
        [roles],
    );

    const getRoleDisplayName = useCallback((code: string) => roleDisplayNames.get(code) ?? code, [roleDisplayNames]);

    return { roles, rolesLoading, getRoleDisplayName };
};
